import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import LoadingOverlay from '../Loading/LoadingOverlay';
import { isExplicitlyLoggedOut } from '../../utils/authSession';
import { getLocationRedirect } from '../../utils/authRedirect';

export default function RequireAuth({ children }) {
  const { data: user, loading, bootstrapped } = useSelector((state) => state.user);
  const location = useLocation();

  if (!bootstrapped || loading) return <LoadingOverlay />;

  if (!user || isExplicitlyLoggedOut()) {
    return (
      <Navigate
        to="/auth"
        replace
        state={{ from: getLocationRedirect(location) }}
      />
    );
  }

  return children;
}
